export const click4WheelsStations = [
  { code: "ADLT01", name: "Adelaide Airport" },
  { code: "ADLS01", name: "Adelaide Clovelly Park" },
  { code: "ADLN03", name: "Adelaide Collinswood" },
  { code: "ASPT01", name: "Alice Springs Airport" },
  { code: "BSJC01", name: "Bairnsdale" },
  { code: "BNET01", name: "Brisbane Airport" },
  { code: "BNES02", name: "Brisbane Archerfield" },
  { code: "BNEC04", name: "Brisbane City Commercials" },
  { code: "BNEW03", name: "Brisbane Ipswich" },
  { code: "BMET01", name: "Broome Airport" },
  { code: "CNST01", name: "Cairns Airport" },
  { code: "CBRT01", name: "Canberra Airport" },
  { code: "CFST03", name: "Coffs Harbour Airport" },
  { code: "DRWT01", name: "Darwin Airport" },
  { code: "EXMC02", name: "Exmouth City" },
  { code: "EXMT02", name: "Exmouth Learmonth Airport" },
  { code: "OOLT01", name: "Gold Coast Airport" },
  { code: "HVBT02", name: "Hervey Bay Airport" },
  { code: "HBAT02", name: "Hobart Airport" },
  { code: "LSTT02", name: "Launceston Airport" },
  { code: "MKYT01", name: "Mackay Airport" },
  { code: "MCYT01", name: "Maroochydore Airport" },
  { code: "MELT01", name: "Melbourne Airport" },
  { code: "MELN13", name: "Melbourne Campbellfield" },
  { code: "MELC01", name: "Melbourne City" },
  { code: "MELE02", name: "Melbourne Dandenong" },
  { code: "NTLT02", name: "Newcastle Airport" },
  { code: "ZNET01", name: "Newman Airport" },
  { code: "PERT01", name: "Perth Airport" },
  { code: "PLOT01", name: "Port Lincoln Airport" },
  { code: "PPPT01", name: "Proserpine Airport" },
  { code: "ROKT01", name: "Rockhampton Airport" },
  { code: "SYDT01", name: "Sydney Airport" },
  { code: "SYDW06", name: "Sydney Parramatta" },
  { code: "TSVT01", name: "Townsville Airport" },
];
